(function (angular) {
	'use strict';

	angular
		.module('forgotPasswordModule', [
			'coreModule',
			'formValidationModule',
			'googleRecaptchaModule',
			'vcRecaptcha'
		])
		.value('globalConfig', globalConfig);
})(window.angular);